import React from 'react';
import * as _ from 'lodash';
import { deleteControlCode } from '../../utilities/stringUtil';
import { TrashIcon } from '../icons/TrashIcon';
import ComboBox from '../combobox/ComboBox';

export const MultiComboBoxBlock = ({
  targetValues,
  events,
  disabledAll,
  comboBoxList,
  keyParams,
}) => {
  return _.map(targetValues, (value, index) => {
    return (
      <div
        key={index}
        className={`form-list__element-select ${
          disabledAll ? 'form-list__element-select--disabled' : ''
        }`}
      >
        <ComboBox
          key={index}
          listId={`${keyParams.targetKey}-list`}
          disabled={disabledAll}
          value={value[keyParams.searchKey]}
          comboBoxList={comboBoxList}
          comboBoxValueKey={keyParams.searchKey}
          onChange={e =>
            events.inputValueSearch(
              [...targetValues],
              comboBoxList,
              deleteControlCode(e.target.value),
              index,
              keyParams
            )
          }
        />
        {disabledAll === false && (
          <button
            onClick={() =>
              events.deleteValue([...targetValues], index, keyParams)
            }
            className='btn-icon--xs form-list__element--btn_delete'
          >
            <TrashIcon className='icon--2_4x form-list__trash-icon' />
          </button>
        )}
      </div>
    );
  });
};



// WEBPACK FOOTER //
// ./src/components/worker/CommonDropDown.jsx